"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ethers_1 = require("ethers");
const secp256k1_1 = __importDefault(require("secp256k1"));
const encryption_utils_1 = __importDefault(require("./utils/encryption.utils"));
class KeyPair {
    constructor(id) {
        this.id = id;
    }
    generate() {
        const wallet = ethers_1.Wallet.createRandom({});
        this.privateKey = KeyPair.toUint8Array(wallet.privateKey).subarray(0, 32);
        this.publicKey = this.derivePublic(this.privateKey);
        this.mnemonic = wallet.mnemonic.phrase;
        return this;
    }
    fromMnemonic(mnemonic) {
        const wallet = ethers_1.Wallet.fromMnemonic(mnemonic);
        this.privateKey = KeyPair.toUint8Array(wallet.privateKey).subarray(0, 32);
        this.publicKey = this.derivePublic(this.privateKey);
        this.mnemonic = wallet.mnemonic.phrase;
        return this;
    }
    fromPrivate(privateKey) {
        this.privateKey = privateKey;
        this.publicKey = this.derivePublic(privateKey);
        return this;
    }
    get() {
        return {
            private: this.privateKey,
            public: this.publicKey,
            mnemonic: this.mnemonic,
        };
    }
    getAsString() {
        if (!this.privateKey || !this.publicKey)
            throw new Error("Please initialize keys first.");
        return {
            private: KeyPair.fromUint8Array(this.privateKey),
            public: KeyPair.fromUint8Array(this.publicKey),
            mnemonic: this.mnemonic,
        };
    }
    derivePublic(privateKey) {
        return secp256k1_1.default.publicKeyCreate(privateKey, true);
    }
    encrypt(toPublicKey, message, toHex = true) {
        if (!this.privateKey)
            throw new Error("Please initialize keys first.");
        const sharedKey = encryption_utils_1.default.getSharedKey(this.privateKey, toPublicKey);
        const msg = typeof message === "string" ? KeyPair.toUint8Array(message) : message;
        return encryption_utils_1.default.encrypt(sharedKey, msg, toHex);
    }
    decrypt(fromPublicKey, message) {
        if (!this.privateKey)
            throw new Error("Please initialize keys first.");
        const sharedKey = encryption_utils_1.default.getSharedKey(this.privateKey, fromPublicKey);
        return encryption_utils_1.default.decrypt(sharedKey, message);
    }
    // encryptGroupChatMessage(message: Uint8Array | string, users: User[]) {
    //   if (!this.privateKey) throw new Error("Please initialize keys first.");
    //   const chatKey = new KeyPair("").generate().get().private!;
    //   let midKeys: { [id: string]: string } = {};
    //   for (let user of users) {
    //     const sharedKey = EncryptionModule.getSharedKey(
    //       this.privateKey,
    //       user.publicKey
    //     );
    //     midKeys[user.id] = EncryptionModule.encrypt(
    //       sharedKey,
    //       chatKey,
    //       true
    //     ) as string;
    //   }
    //   const msg =
    //     typeof message === "string" ? KeyPair.toUint8Array(message) : message;
    //   return {
    //     encryptedContent: EncryptionModule.encrypt(chatKey, msg, true) as string,
    //     midKeys: midKeys,
    //     encrypted: true,
    //   } as EncryptedMessage;
    // }
    // decryptGroupChatMessageAsSender(
    //   encryptedMessage: EncryptedMessage,
    //   oneOfReceivers: User
    // ) {
    //   if (!this.privateKey) throw new Error("Please initialize keys first.");
    //   const sharedKey = EncryptionModule.getSharedKey(
    //     this.privateKey,
    //     oneOfReceivers.publicKey
    //   );
    //   const chatKey = EncryptionModule.decrypt(
    //     sharedKey,
    //     encryptedMessage.midKeys[oneOfReceivers.id],
    //     false
    //   ) as Uint8Array;
    //   return EncryptionModule.decrypt(
    //     chatKey,
    //     encryptedMessage.encryptedContent,
    //     true
    //   );
    // }
    // decryptGroupChatMessageAsReceiver = (
    //   { midKeys, encryptedContent }: EncryptedMessage,
    //   { publicKey: senderPublicKey }: User
    // ) => {
    //   if (!this.privateKey) throw new Error("Please initialize keys first.");
    //   const sharedKey = EncryptionModule.getSharedKey(
    //     this.privateKey,
    //     senderPublicKey
    //   );
    //   const chatKey = EncryptionModule.decrypt(
    //     sharedKey,
    //     midKeys[this.id],
    //     false
    //   ) as Uint8Array;
    //   return EncryptionModule.decrypt(chatKey, encryptedContent, true);
    // };
    static fromUint8Array(array) {
        return new TextDecoder().decode(array);
    }
    static toUint8Array(string) {
        return new TextEncoder().encode(string);
    }
}
exports.default = KeyPair;
